<template>
  <div>
    <p class="category">Sentiment Analysis for Code-Switched Text</p>
    <div class="container text-left">
      <p>
        In social media, the text is becoming increasingly important due to its effectiveness in disseminating
        information in highly individualized and opinionated contexts. Affective analysis has been studied using
        different Natural Language Processing (NLP) methods from various linguistic perspectives such as semantic,
        syntactic, and cognitive properties. Social media text is often written in a code-switching style in certain
        parts of the world, such as Mainland China and Hong Kong.
      </p>
      <p>
        This task aims to identify the users' sentiment from their comments. In this dataset, the instances are mainly
        written in Cantonese. Other languages are used, including English, French, Japanese, etc. The label classes are
        from 1-star to 5-star, forming a multi-class task.
      </p>
       <p>
        The dataset is organized in the tsv format. Each row is in the format of '{Text}\t{Label}'.
        The table below presents an example for the task.
      </p>
      <div class="my-3">
        <el-table :data="tableData" style="width: 100%" border>
          <el-table-column prop="text" label="Text" min-width="600"></el-table-column>
          <el-table-column prop="label" label="Label" min-width="150"></el-table-column>
        </el-table>
      </div>
      <div>
        <span class="h6 mr-2">Data resources: </span>
        <a href="/resource_social22/data/data_code.zip">data_code.zip</a>
      </div>
      <div>
        <span class="h6 mr-2">Baseline Implementation: </span>
        <a href="/resource_social22/data/src_code.zip">src_code.zip</a>
      </div>
      <p class="mt-3">Uploading results should be saved as a <strong>.txt</strong> file like this:</p>
      <v-card class="px-3 py-2">
        <div>1</div>
        <div>2</div>
        <div>3</div>
      </v-card>
      <p>Where each row represents a label.</p>
    </div>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";

export default {
  name: "taskCode",
  // components: {codemirror},
  data(){
    return {
      tableData: [
        {
          'text': '我覺得麻麻jer~ dessert buffet gei cheese cake都唔多選擇... 同埋冇咩特別~ 環境就好好呀~ $155+10%...4',
          'label': '4',
        }
      ],
      code: '1\n2\n3',
      cmOptions: {
        mode: "text/javascript",
        theme: "ttcn",
      },
    }
  },
  methods: {
    data2str(data) {
      return JSON.stringify(data);
    },
  },
}
</script>

<style scoped>

</style>